"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Import orchestrators so they get registered
require("./orchestrators/removeMessageAdClearListOrchestrator");
var loadMessageAdList_1 = require("./orchestrators/loadMessageAdList");
exports.loadMessageAdList = loadMessageAdList_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/owa-mail-messagead-orchestration/lib/index.js
// module id = 3913
// module chunks = 67